import { render, staticRenderFns } from "./vtp-desc.vue?vue&type=template&id=1140bef1"
import script from "./vtp-desc.vue?vue&type=script&lang=js"
export * from "./vtp-desc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports